// TODO: Delete this once all clients are crazy-chat (it handles typing by itself)
import firebaseChatService from './firebaseChatService';
import { TYPING_DEBOUNCE_INTERVAL } from '../constants/typing-intervals';

class TypingService {
  private stopTypingTimeout;

  notifyTyping() {
    if (this.stopTypingTimeout) {
      clearTimeout(this.stopTypingTimeout);
    }

    this.stopTypingTimeout = setTimeout(
      () => this.setTypingState(false),
      TYPING_DEBOUNCE_INTERVAL,
    );

    if (!firebaseChatService.isTyping()) {
      this.setTypingState(true);
    }
  }

  setTypingState(typing: boolean) {
    firebaseChatService.updatePresence({
      typing,
    });
  }
}

export default new TypingService();
